"use strict";

import "./VehiclePOICrossingsStays.css";
import React from "react";

import dispatcher from "./../../dispatcher";

import getVehicleActivity from "./../../api/getVehicleActivity";

import vehiclePOICrossingStore from "./../../store/vehiclePOICrossings";

import Card from "vwa/components/Card";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import {getBoundsOfPOI} from "./../../utils/poi";
import vehiclePOICrossingUtils from "./../../utils/vehiclePOICrossing";

import StayCard from "./StayCard";

export default class VehiclePOICrossingsStays extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = Object.assign({
			fixedData: []
		}, this.getStoreDependentState());
	}
	
	getStoreDependentState() {
		
		const vehiclePOICrossingsDescriptor = vehiclePOICrossingStore.get(this.props.vehicleId);
		
		return {
			from: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.from : null,
			to: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.to : null,
			pois: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.poi : [],
			sections: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.result.sections : null,
		};
	}
		
	setStoreListeners(){
		this.eep.on(vehiclePOICrossingStore, "insert", descriptors => {
			const descriptor = descriptors.find(d => d.vehicle == this.props.vehicleId);
			if (descriptor) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehiclePOICrossingStore, "update", descriptor => {
			if (descriptor.vehicle == this.props.vehicleId) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehiclePOICrossingStore, "remove", vehicleIds => {
			if (vehicleIds.find(id => id == this.props.vehicleId))
				this.setState(this.getStoreDependentState());
		});
	}
		
	componentWillUnmount() {
		this.eep.close();
	}
	
	focusPOI(poi) {
		dispatcher.dispatch('setMap', {
			bounds: getBoundsOfPOI(poi).toJSON()
		});
	}
	
	handleFixData(which) {
		const prevFixedData = Array.from(this.state.fixedData);
		const index = prevFixedData.indexOf(which);
		if (index > -1) {
			prevFixedData.splice(index, 1);
		} else {
			prevFixedData.push(which);
		}
		this.setState({
			fixedData: prevFixedData
		});
	}
	
	handleGetActivity(from, to){
		dispatcher.dispatch("switchDetailsPage", this.props.vehicleId, "activity");
		getVehicleActivity(this.props.vehicleId, from, to, 0);
	}
	
	highlightVehiclePOICrossing(time){
		dispatcher.dispatch("highlightVehiclePOICrossing", this.props.vehicleId, time);
	}
	
	unhighlightVehiclePOICrossing(time){
		dispatcher.dispatch("unhighlightVehiclePOICrossing", this.props.vehicleId, time);
	}
	
	renderStays() {
		if (!this.state.sections || (this.state.sections && this.state.sections.length == 0)){
			return null;
		}
		
		return this.state.sections.map((section, index) => 
			(
				<StayCard
					key={index}
					section={vehiclePOICrossingUtils.getResolvedSection(section)}
					fixedData={this.state.fixedData}
					onClick={_ => this.focusPOI(section.poi)}
					onAddressClick={crossingTime => vehiclePOICrossingUtils.focusOnVehiclePOICrossing(this.props.vehicleId, crossingTime)}
					onAddressMouseOver={crossingTime => this.highlightVehiclePOICrossing(crossingTime)}
					onAddressMouseLeave={crossingTime => this.unhighlightVehiclePOICrossing(crossingTime)}
					onFixData={which => this.handleFixData(which)}
					onGetActivity={(from, to) => this.handleGetActivity(from, to)}
				/>
			)
		);
	}
	
	render(){
		return (
			<div className="VehiclePOICrossingsStays">
				{this.renderStays()}
			</div>
		);
	}
	
}

VehiclePOICrossingsStays.propTypes = {
	vehicleId: React.PropTypes.string
};

VehiclePOICrossingsStays.defaultProps = {
	vehicleId: null
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossingsStays/VehiclePOICrossingsStays.jsx